export enum TextErrorMessages {
  RequiredField = 'This is a required field.',
  MinLength = 'The entered text is too short.',
  PatternMatch = 'Must be formatted like',
  InvalidSecondVatNumber = 'The Establishment Unit Number you entered is invalid. Please ensure it is a 10-digit number starting with 2-8',
  NoError = '',
  CanadianPostalCodePattern = 'Please enter a valid postal code in the format A1A 1A1 OR A1A1A1',
  InvalidBelgianNumberFormat = 'The check digit is incorrect. Please enter a valid value.'
}
